import { defaultMetricMap, calloutMap } from 'constants/callouts';
import { formatByType } from 'helpers/formatNumbers';

exports.getDefaultMetricMap = () => defaultMetricMap;

exports.getCalloutMap = () => calloutMap;

exports.createMetricMap = ({ getActivitiesSettings, initialMetricMap, entityObjective, entityObjectiveLabelCode }) => {
    const metricMap = {
        default: initialMetricMap,
    };

    if (entityObjective && entityObjectiveLabelCode && entityObjectiveLabelCode !== 'default') {
        const {
            singularTerm,
            pluralTerm
        } = getActivitiesSettings(entityObjective, entityObjectiveLabelCode);

        Object.assign(metricMap, {
            [entityObjectiveLabelCode]: {
                ...initialMetricMap,
                total_activities: {
                    ...initialMetricMap.total_activities,
                    title: `Total ${pluralTerm}`
                },
                ecpa_activities: {
                    ...initialMetricMap.ecpa_activities,
                    title: pluralTerm
                },
                ecpa: {
                    ...initialMetricMap.ecpa,
                    title: `Cost / ${singularTerm}`
                },
                cost_per_conversion: {
                    ...initialMetricMap.cost_per_conversion,
                    title: `Cost / ${singularTerm}`
                },
                conversions: {
                    ...initialMetricMap.conversions,
                    title: pluralTerm
                },
                conversion_rate: {
                    ...initialMetricMap.conversion_rate,
                    title: `${singularTerm} Rate`
                }
            }
        });
    }

    return metricMap;
};

exports.createCalloutValues = ({ calloutData, metric, title, format = 'number', invert = false }) => {
    const value = calloutData ? calloutData[`current_${metric}`] : 0;
    const valueDisplay = formatByType(value, format);
    const change = calloutData ? Math.round(calloutData[`${metric}_per_delta`], 0) : 0;
    const deltaVisible = calloutData.completeData;

    let mapKey = 'normal-neutral';
    const invertedKey = invert ? 'invert' : 'normal';

    if (change > 0) {
        mapKey = `${invertedKey}-positive`;
    } else if (change < 0) {
        mapKey = `${invertedKey}-negative`;
    }
    return {
        metric,
        title,
        deltaVisible,
        value: valueDisplay,
        deltaState: mapKey,
    };
};



// WEBPACK FOOTER //
// ./src/helpers/callouts.js